/* MKPBR Black November 2026 (visual 2, 30/10) — contagem regressiva (oferta do dia), selo da página de produto ao trocar de variante
   e aviso do carrinho (gaveta lateral .mkcd e página /cart). Carregado por snippets/mkpbr-bf-faixa.liquid só com a BF ligada.
   Configuração: <script id="mkbf-cfg"> (textos no idioma da página). Sem bibliotecas. */
(function () {
  var cfgEl = document.getElementById('mkbf-cfg');
  if (!cfgEl) return;
  var C = {};
  try { C = JSON.parse(cfgEl.textContent) || {}; } catch (e) {}
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  /* contagem HH:MM:SS (snippets/mkpbr-bf-cd): conta contra o instante absoluto do fim (Date.now()), sem depender do fuso
     do aparelho. Zerou: esconde o relógio e mostra "Nova oferta em instantes" (data-nova="1"); 1 h depois do fim, ou sem
     oferta no dia seguinte, some. Sem animação (só troca os números). */
  function tick() {
    var els = document.querySelectorAll('[data-mkbf-cd]'), now = Date.now();
    for (var i = 0; i < els.length; i++) {
      var el = els[i], fim = (+el.getAttribute('data-mkbf-cd')) * 1000;
      if (!fim) continue;
      var r = Math.floor((fim - now) / 1000);
      if (r > 0) {
        if (el.hidden) el.hidden = false;
        if (el.classList.contains('is-nova')) el.classList.remove('is-nova');
        var hh = pad(Math.floor(r / 3600)), mm = pad(Math.floor(r % 3600 / 60)), ss = pad(r % 60);
        /* 30/10 (visual Black November): números separados (dois-pontos em rosa); sem eles, o texto inteiro */
        var sh = el.querySelector('[data-cd-h]');
        if (sh) {
          var sm = el.querySelector('[data-cd-m]'), sx = el.querySelector('[data-cd-s]');
          if (sh.textContent !== hh) sh.textContent = hh;
          if (sm && sm.textContent !== mm) sm.textContent = mm;
          if (sx && sx.textContent !== ss) sx.textContent = ss;
        } else {
          var b = el.querySelector('[data-cd]'), txt = hh + ':' + mm + ':' + ss;
          if (b && b.textContent !== txt) b.textContent = txt;
        }
      } else if (el.getAttribute('data-nova') === '1' && r > -3600) {
        if (!el.classList.contains('is-nova')) el.classList.add('is-nova');
      } else if (!el.hidden) {
        el.hidden = true;
      }
    }
    return els.length;
  }
  /* nunca mais desconto do que o real: para baixo; múltiplo de 5 só se o real estiver até 0,5 ponto abaixo (19,6 -> 20; 18,5 -> 18) */
  function snap(p) { var q = Math.ceil(p / 5 - 1e-9) * 5; return (q - p) <= 0.5 ? q : Math.floor(p + 1e-9); }
  function variantId() {
    var u = new URLSearchParams(location.search).get('variant');
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return (inp && inp.value) || u || '';
  }
  function pdp() {
    var els = document.querySelectorAll('[data-mkbf-pdp]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.hasAttribute('data-sim')) continue;
      var vm = {};
      (el.getAttribute('data-vm') || '').split(',').forEach(function (x) { var a = x.split(':'); vm[a[0]] = [+a[1], +a[2]]; });
      var v = vm[variantId()];
      if (!v) continue;
      /* só mexe quando muda: o selo fica dentro do bloco de preço observado (evita repetição sem fim) */
      if (v[1] > v[0]) {
        var p = snap((v[1] - v[0]) * 100 / v[1]), txt = '−' + p + '%';
        if (el.hidden) el.hidden = false;
        var t = el.querySelector('[data-mkbf-p]');
        if (t && t.textContent !== txt) {
          t.textContent = txt;
          el.setAttribute('aria-label', (el.getAttribute('aria-label') || '').replace(/\d+/, p));
        }
      } else if (!el.hidden) {
        el.hidden = true;
      }
    }
  }
  function note() {
    if (!C.cart) return;
    [['.mkcd__panel .mkcd__hd', 'afterend'], ['.cart-title-left > h1', 'afterend']].forEach(function (s) {
      var el = document.querySelector(s[0]);
      if (el && !el.parentNode.querySelector('.mkbf-cartnote')) {
        var d = document.createElement('p');
        d.className = 'mkbf-cartnote';
        d.textContent = C.cart;
        el.insertAdjacentElement(s[1], d);
      }
    });
  }
  function init() {
    if (tick()) setInterval(tick, 1000);
    if (document.querySelector('[data-mkbf-pdp]')) {
      pdp();
      document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id' || e.target.closest && e.target.closest('form[action*="/cart/add"]')) setTimeout(pdp, 0); });
      var pr = document.querySelector('[data-product-pricing]');
      if (pr && window.MutationObserver) new MutationObserver(function () { setTimeout(pdp, 0); }).observe(pr, { childList: true, subtree: true, characterData: true });
    }
    note();
    if (window.MutationObserver) new MutationObserver(note).observe(document.body, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
